import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSearchSelectorComponent } from './mat-search-selector/mat-search-selector.component';
import { MatSearchSelectorDirective } from './mat-search-selector.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSearchSelectorItemsDirective } from './mat-search-selector-items.directive';
@NgModule({
  declarations: [MatSearchSelectorComponent, MatSearchSelectorDirective, MatSearchSelectorItemsDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  exports: [
    MatSearchSelectorComponent, MatSearchSelectorDirective, MatSearchSelectorItemsDirective
  ]
})
export class MatSearchSelectorModule { }
